export default __webpack_public_path__ + "static/media/step3.82a414a7.webp";